import { Container } from "./style/SubGraphOperator.styled";
import SubGraphOperatorFieldView from "./view/SubGraphOperatorField.view";

export default function SubGraphOperatorComponent (props) {
    return (
        <Container>
            <SubGraphOperatorFieldView
                checkedSwitch={props.checkedSwitch}
                optionListSize={props.optionListSize}

                onActionChangeSwitch={props.onActionChangeSwitch}
                onActionChangeOptionListSize={props.onActionChangeOptionListSize}
            />
        </Container>
    )
}